// please do not modify this file
// this file is used for autoCommitPush.sh

export const APP_VERSION = '151';
